export const DEFAULT_INITIAL_IMAGE_URL = "/scene-default.png";

export function normalizeInitialImageUrl(value: unknown) {
  if (value === undefined || value === null) return undefined;
  if (typeof value !== "string") throw new Error("初始图片地址格式不正确");

  const trimmed = value.trim();
  if (!trimmed) return undefined;
  if (trimmed.length > 4096) throw new Error("初始图片地址过长");
  if (/^(https?:\/\/|\/)/i.test(trimmed)) return trimmed;

  throw new Error("初始图片地址需要以 /、https:// 或 http:// 开头");
}

export function resolveInitialImageUrl(clientValue: unknown, defaultValue?: string) {
  if (clientValue !== undefined) return normalizeInitialImageUrl(clientValue);
  return normalizeInitialImageUrl(defaultValue ?? DEFAULT_INITIAL_IMAGE_URL);
}
